import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCRUD, CRUDService, ExceptionService, UtilsService } from '../../../xform-compat';
import { MyCompany } from '../../../shared/models';


/**
 * Data service for the CRUD of My Companies
 */
@Injectable({
  providedIn: 'root'
})
export class MyCompanyService extends AbstractCRUD<MyCompany> implements CRUDService<MyCompany> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath(): string {
    return '/rms/companies/follow/me';
  }
}
